import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import AxiosConfig from "./AxiosConfig";
import "antd/dist/reset.css";
import { ConfigProvider, message } from "antd";
import { IntlProvider } from "react-intl";
import localeMessage from "./locales";
import en from "antd/locale/en_US";
import zh from "antd/locale/zh_CN";
import ja from "antd/locale/ja_JP";
import ru from "antd/locale/ru_RU";
import ar from "antd/locale/ar_EG";
import mn from "antd/locale/mn_MN";
import ko from "antd/locale/ko_KR";
import vi from "antd/locale/vi_VN";

import "dayjs/locale/ko";
import "dayjs/locale/en";
import "dayjs/locale/zh-cn";
import "dayjs/locale/ru";
import "dayjs/locale/ar";
import "dayjs/locale/mn";
import "dayjs/locale/ja";
import "dayjs/locale/vi";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

const theme = {
	token: {
		colorPrimary: "#006869",
	},
	components: {
		Divider: {
			colorSplit: "#dddddd",
		},
		Button: {
			primaryShadow: "none",
		},
	},
};

const locales = {
	ko: { antd: ko, messages: localeMessage.ko },
	en: { antd: en, messages: localeMessage.en },
	zh: { antd: zh, messages: localeMessage.zh },
	ru: { antd: ru, messages: localeMessage.ru },
	ar: { antd: ar, messages: localeMessage.ar },
	mn: { antd: mn, messages: localeMessage.mn },
	ja: { antd: ja, messages: localeMessage.ja },
	vi: { antd: vi, messages: localeMessage.vi },
};

const locale = localStorage.getItem("locale") || "en";
if (!localStorage.getItem("locale")) localStorage.setItem("locale", "en");

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 0, suspense: true, cacheTime: 3600000, refetchOnWindowFocus: false } } });

const currentLocale = locales[locale] || locales["en"];

// static message.* 기본 표시 시간 5초
message.config({ duration: 5 });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<IntlProvider locale={locale} messages={currentLocale.messages}>
			<ConfigProvider locale={currentLocale.antd} theme={theme} message={{ duration: 5 }}>
				<QueryClientProvider client={queryClient}>
					{!process.env.REACT_APP_API_URL && <ReactQueryDevtools initialIsOpen={false} />}
					<AxiosConfig>
						<App />
					</AxiosConfig>
				</QueryClientProvider>
			</ConfigProvider>
		</IntlProvider>
	</React.StrictMode>
);
